export default __webpack_public_path__ + "static/media/sp.32e1e489.svg";